import React from "react";
import MainLayout from "../../layouts/MainLayout";
import SyncNextStyleHead from "../../components/seo/SyncNextStyleHead";
// import { getQuoteCorporate } from "../../util/getQuoteCorporate";
import CorporateLeadFormPageGurgaon from "../../modules/landingpages/CorporateLeadFormPageGurgaon";

function GetQuotePageCorporateDelhiNcr() {
  return (
    <MainLayout>
      {/* <SyncNextStyleHead>{getQuoteCorporate()}</SyncNextStyleHead> */}
      <CorporateLeadFormPageGurgaon />
    </MainLayout>
  );
}

export default GetQuotePageCorporateDelhiNcr;
